export default class AppGeocode {
    constructor () {
        this.maps = {};
        this.initAll();
    }

    initAll () {
        let self = this;
        $('[data-toggle=geocode]').each(function () {
            self.init($(this));
        });
    }

    init ($input) {
        let name = $input.attr('name');
        let mapSelector = $input.attr('data-map-selector');
        let defaultCenter = new google.maps.LatLng({lat: 53.551085, lng: 9.993682});
        let location = false;
        let lat = $('[name=' + name + '_lat]').val();
        let lng = $('[name=' + name + '_lng]').val();
        if (lat && lng) {
            location = [lat, lng];
        }
        $input.geocomplete({
            details: '#geocode-' + name,
            detailsAttribute: 'data-geocode',
            map: $(mapSelector),
            location: location,
            bounds: null,
            types: [],
            mapOptions: {
                center: defaultCenter,
                styles: [
                    {
                        featureType: 'poi',
                        elementType: 'labels',
                        stylers: [{visibility: 'off'}],
                    },
                ],
            },
        });

        $input
            .on('blur', function () {
                let geocode = $input.data('plugin_geocomplete');
                let value = $input.val();
                let address = geocode.data ? geocode.data.formatted_address : value;
                if (value !== address) {
                    if (geocode.map) {
                        geocode.map.setCenter(defaultCenter);
                    }
                    if (geocode.marker) {
                        geocode.marker.setMap(null);
                    }
                    if (geocode.details) {
                        $.each(geocode.details, function (key, $detail) {
                            geocode.setDetail($detail, '');
                        });
                    }
                    geocode.data = {};
                    $input.val(value);
                }
            })
            .on('geocode:result', function () {
                let geocode = $input.data('plugin_geocomplete');
                if (geocode.map && geocode.marker) {
                    geocode.marker.setMap(geocode.map);
                }
            })
        ;
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/geocode.js